import React, { useEffect, useState } from 'react';
import Table from 'components/usermanagement/Table';
import DeleteModal from 'components/general/DeleteModal';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { DELETE_USER, FETCH_USERS } from 'actions/userActions';
import Pagination from 'components/general/Pagination';
import { Spinner } from 'react-bootstrap';
import { IconFilter, IconPlus, IconSearch } from '@tabler/icons-react';
import 'view/allForms/AllForms.scss';

const UserManagement = () => {
  const { users, totalPages = '', totalResults = '', loading } = useSelector((state) => state.users);
  const dispatch = useDispatch();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteUserId, setDeleteUserId] = useState(null);
  const [filterSettings, setFilterSettings] = useState({
    page: 1,
    limit: 20,
    sortBy: '-createdAt',
    search: '',
  });
  const handleCloseDeleteModel = () => {
    setShowDeleteModal(false);
  };
  // Options abstracted natively to UI select component

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchUsers();
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [JSON.stringify(filterSettings)]);

  const fetchUsers = () => {
    const params = {
      page: filterSettings.page,
      limit: filterSettings.limit,
      sortBy: filterSettings.sortBy,
      ...(filterSettings.role && { role: filterSettings.role }),
      ...(filterSettings.search && { search: filterSettings.search }),
    };

    dispatch({
      type: FETCH_USERS,
      payload: params,
    });
  };

  const setRole = (option) => {
    setFilterSettings((prev) => ({
      ...prev,
      role: option.value === '' ? undefined : option.value,
    }));
  };

  const handleDeleteBtn = (userId) => {
    setDeleteUserId(userId);
    setShowDeleteModal(true);
  };

  const onRemove = () => {
    dispatch({ type: DELETE_USER, payload: deleteUserId });
    setShowDeleteModal(false);
  };

  const changePage = ({ selected: pageIndex }) => {
    setFilterSettings((state) => ({ ...state, page: pageIndex + 1 }));
  };

  return (
    <div className="all-forms-page">
      <div className="page-body">
        <div className="container-xl new_application">

          <div className="glass-panel filter-section mb-4">
            <div className="d-flex gap-3 flex-wrap align-items-center">
              <div className="filter-input-wrapper" style={{ flexGrow: 1, maxWidth: '250px' }}>
                <IconSearch size={18} className="filter-icon" />
                <input
                  type="text"
                  placeholder="Search by name, email or phone"
                  className="premium-input w-100"
                  style={{ paddingLeft: '40px' }}
                  value={filterSettings.search}
                  onChange={(e) => setFilterSettings(prev => ({ ...prev, search: e.target.value, page: 1 }))}
                />
              </div>

              <div className="filter-input-wrapper" style={{ flexGrow: 1, maxWidth: '210px' }}>
                <IconFilter size={18} className="filter-icon" />
                <select
                  value={filterSettings.role || ''}
                  onChange={(e) => setRole({ value: e.target.value })}
                  className="premium-input premium-select w-100"
                >
                  <option value="">Filter by Role</option>
                  <option value="admin">Admin</option>
                  <option value="engineer">Engineer</option>
                  <option value="contractor">Contractor</option>
                  <option value="quality">CZ Quality</option>
                  <option value="manager">CZ Manager</option>
                  <option value="operations">Operations</option>
                  <option value="maintenance">Maintenance</option>
                </select>
              </div>

              <div className="d-flex gap-2 ms-auto align-items-center">
                <Link to="/usermanagement/add" className="btn btn-primary premium-btn px-2 rounded-circle shadow-sm" style={{ width: '38px', height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} title="Add User">
                  <IconPlus size={20} stroke={2.5} />
                </Link>
              </div>
            </div>
          </div>

          <div className="glass-panel table-section">
            <div className="col-12">
              {loading ? (
                <div className="loader-container d-flex justify-content-center py-5">
                  <Spinner animation="border" role="status" variant="primary">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                </div>
              ) : (
                <>
                  <Table data={users} handleDeleteBtn={handleDeleteBtn} />
                  <div className="mt-4 d-flex justify-content-end">
                    <Pagination
                      total={totalResults}
                      handlePageClick={changePage}
                      currentPage={filterSettings.page}
                      limit={filterSettings.limit}
                      totalPages={totalPages}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {showDeleteModal && <DeleteModal show={showDeleteModal} title="User" onClose={handleCloseDeleteModel} onRemove={onRemove} />}
    </div>
  );
};
export default UserManagement;
